import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  label {
    width: 100%;
    height: 56px;

    .MuiButtonBase-root {
      width: 100%;
      height: 100%;
      line-height: 120%;
    }
  }
`;

export const TextFieldContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  position: relative;
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
  vertical-align: top;
  width: 100%;
`;

export const Error = styled.p`
  color: #d32f2f;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin-top: 3px;
  margin-right: 14px;
  margin-bottom: 0;
  margin-left: 14px;
`;
